import { AbstractControl } from "@angular/forms";

export function noWhitespace(control: AbstractControl) {
    const value = control.value?.trim() || '';
    return (value === '') ? { 'whitespace': true } : null
}